import { render, staticRenderFns } from "./officeForm.vue?vue&type=template&id=225a8bc8&scoped=true&"
import script from "./officeForm.vue?vue&type=script&lang=js&"
export * from "./officeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a8bc8",
  null
  
)

export default component.exports